module.exports = __webpack_public_path__ + "assets/125247c203fe879cc53041055bc98bf9.mp3";